const PUSETOS_HARDCODED_YPF = [
  {
    idPuesto: 5,
    idTerminalTarjeta: 0,
    nombre: "PLAYA-CA-4",
    combustiblesSoloPorDespachos: true,
    decimalesParaCantidad: 6,
    decimalesParaImporte: 4,
    verSaldoCliente: true,
    habilitarCambioListaPrecio: 0,
    habilitarAltaClientes: true,
    pideDepositoAlFacturar: false,
    idGrupoManguerasAForzar: 2,
    caja: {
      idCaja: 1,
      cantidadPlayerosSolicitados: 0,
      descripcion: "PLAYA",
      involucraTanques: false,
      involucraSurtidores: false,
      solicitarAforadores: true,
      estacion: null,
    },
    talonarios: [
      {
        idTalonario: 28,
        idDeposito: 1,
        descripcionTalonario: "FAA - PV 141",
        talonarioElectronico: false,
        pathCertificadoFAE: null,
        puntoVenta: 141,
        copias: 1,
        perteneceFULL: false,
        talonarioDocumentos: [
          {
            idTipoMovimiento: "FAA",
          },
          {
            idTipoMovimiento: "NCA",
          },
          {
            idTipoMovimiento: "NDA",
          },
          {
            idTipoMovimiento: "FAA",
          },
          {
            idTipoMovimiento: "NCA",
          },
          {
            idTipoMovimiento: "NDA",
          },
        ],
      },
      {
        idTalonario: 29,
        idDeposito: 1,
        descripcionTalonario: "FAB - PV 141",
        talonarioElectronico: false,
        pathCertificadoFAE: null,
        puntoVenta: 141,
        copias: 1,
        perteneceFULL: false,
        talonarioDocumentos: [
          {
            idTipoMovimiento: "FAB",
          },
          {
            idTipoMovimiento: "NCB",
          },
          {
            idTipoMovimiento: "NDB",
          },
          {
            idTipoMovimiento: "FAB",
          },
          {
            idTipoMovimiento: "NCB",
          },
          {
            idTipoMovimiento: "NDB",
          },
          {
            idTipoMovimiento: "BON",
          },
        ],
      },
      {
        idTalonario: 30,
        idDeposito: 1,
        descripcionTalonario: "REM - PV 141",
        talonarioElectronico: false,
        pathCertificadoFAE: null,
        puntoVenta: 141,
        copias: 2,
        perteneceFULL: false,
        talonarioDocumentos: [
          {
            idTipoMovimiento: "REM",
          },
          {
            idTipoMovimiento: "RDV",
          },
          {
            idTipoMovimiento: "REM",
          },
          {
            idTipoMovimiento: "RDV",
          },
        ],
      },
      {
        idTalonario: 55,
        idDeposito: 1,
        descripcionTalonario: "FAE - PV 141",
        talonarioElectronico: true,
        pathCertificadoFAE: null,
        puntoVenta: 141,
        copias: 1,
        perteneceFULL: false,
        talonarioDocumentos: [
          {
            idTipoMovimiento: "FAE",
          },
          {
            idTipoMovimiento: "NCE",
          },
          {
            idTipoMovimiento: "NDE",
          },
          {
            idTipoMovimiento: "FAE",
          },
          {
            idTipoMovimiento: "NCE",
          },
          {
            idTipoMovimiento: "NDE",
          },
        ],
      },
    ],
  },
  {
    idPuesto: 7,
    idTerminalTarjeta: 0,
    nombre: "FULL-CA-1",
    combustiblesSoloPorDespachos: true,
    decimalesParaCantidad: 6,
    decimalesParaImporte: 4,
    verSaldoCliente: true,
    habilitarCambioListaPrecio: 0,
    habilitarAltaClientes: false,
    pideDepositoAlFacturar: false,
    idGrupoManguerasAForzar: null,
    caja: {
      idCaja: 2,
      cantidadPlayerosSolicitados: 0,
      descripcion: "FULL 1",
      involucraTanques: false,
      involucraSurtidores: false,
      solicitarAforadores: false,
      estacion: null,
    },
    talonarios: [
      {
        idTalonario: 62,
        idDeposito: 2,
        descripcionTalonario: "FAA CONSIG - PV 7 CAEA",
        talonarioElectronico: true,
        pathCertificadoFAE: null,
        puntoVenta: 7,
        copias: 1,
        perteneceFULL: true,
        talonarioDocumentos: [
          {
            idTipoMovimiento: "FAA",
          },
          {
            idTipoMovimiento: "FAA",
          },
        ],
      },
      {
        idTalonario: 63,
        idDeposito: 2,
        descripcionTalonario: "FAB CONSIG - PV 7 CAEA",
        talonarioElectronico: true,
        pathCertificadoFAE: null,
        puntoVenta: 7,
        copias: 1,
        perteneceFULL: true,
        talonarioDocumentos: [
          {
            idTipoMovimiento: "FAB",
          },
          {
            idTipoMovimiento: "FAB",
          },
        ],
      },
    ],
  },
  {
    idPuesto: 16,
    idTerminalTarjeta: 0,
    nombre: "TOTEM-PLAYA-1",
    combustiblesSoloPorDespachos: true,
    decimalesParaCantidad: 4,
    decimalesParaImporte: 2,
    verSaldoCliente: true,
    habilitarCambioListaPrecio: 0,
    habilitarAltaClientes: true,
    pideDepositoAlFacturar: false,
    idGrupoManguerasAForzar: 1,
    caja: {
      idCaja: 1,
      cantidadPlayerosSolicitados: 0,
      descripcion: "PLAYA",
      involucraTanques: false,
      involucraSurtidores: false,
      solicitarAforadores: true,
      estacion: null,
    },
    talonarios: [
      {
        idTalonario: 57,
        idDeposito: 2,
        descripcionTalonario: "FAA - PV 999",
        talonarioElectronico: true,
        pathCertificadoFAE: null,
        puntoVenta: 999,
        copias: 1,
        perteneceFULL: true,
        talonarioDocumentos: [
          {
            idTipoMovimiento: "FAA",
          },
          {
            idTipoMovimiento: "NCA",
          },
          {
            idTipoMovimiento: "NDA",
          },
          {
            idTipoMovimiento: "FAA",
          },
          {
            idTipoMovimiento: "NCA",
          },
          {
            idTipoMovimiento: "NDA",
          },
        ],
      },
      {
        idTalonario: 58,
        idDeposito: 2,
        descripcionTalonario: "FAB - PV 999",
        talonarioElectronico: true,
        pathCertificadoFAE: null,
        puntoVenta: 999,
        copias: 1,
        perteneceFULL: true,
        talonarioDocumentos: [
          {
            idTipoMovimiento: "FAB",
          },
          {
            idTipoMovimiento: "NCB",
          },
          {
            idTipoMovimiento: "NDB",
          },
          {
            idTipoMovimiento: "FAB",
          },
          {
            idTipoMovimiento: "NCB",
          },
          {
            idTipoMovimiento: "NDB",
          },
        ],
      },
      {
        idTalonario: 59,
        idDeposito: 2,
        descripcionTalonario: "REM - PV 999",
        talonarioElectronico: false,
        pathCertificadoFAE: null,
        puntoVenta: 999,
        copias: 2,
        perteneceFULL: true,
        talonarioDocumentos: [
          {
            idTipoMovimiento: "REM",
          },
          {
            idTipoMovimiento: "RDV",
          },
          {
            idTipoMovimiento: "REM",
          },
          {
            idTipoMovimiento: "RDV",
          },
        ],
      },
      {
        idTalonario: 60,
        idDeposito: 2,
        descripcionTalonario: "FAA - PV 7 CAEA",
        talonarioElectronico: true,
        pathCertificadoFAE: null,
        puntoVenta: 7,
        copias: 1,
        perteneceFULL: true,
        talonarioDocumentos: [
          {
            idTipoMovimiento: "FAA",
          },
        ],
      },
      {
        idTalonario: 61,
        idDeposito: 2,
        descripcionTalonario: "FAB - PV 7 CAEA",
        talonarioElectronico: true,
        pathCertificadoFAE: null,
        puntoVenta: 7,
        copias: 1,
        perteneceFULL: true,
        talonarioDocumentos: [
          {
            idTipoMovimiento: "FAB",
          },
        ],
      },
      {
        idTalonario: 62,
        idDeposito: 2,
        descripcionTalonario: "FAA CONSIG - PV 7 CAEA",
        talonarioElectronico: true,
        pathCertificadoFAE: null,
        puntoVenta: 7,
        copias: 1,
        perteneceFULL: true,
        talonarioDocumentos: [
          {
            idTipoMovimiento: "FAA",
          },
          {
            idTipoMovimiento: "FAA",
          },
        ],
      },
      {
        idTalonario: 63,
        idDeposito: 2,
        descripcionTalonario: "FAB CONSIG - PV 7 CAEA",
        talonarioElectronico: true,
        pathCertificadoFAE: null,
        puntoVenta: 7,
        copias: 1,
        perteneceFULL: true,
        talonarioDocumentos: [
          {
            idTipoMovimiento: "FAB",
          },
          {
            idTipoMovimiento: "FAB",
          },
        ],
      },
    ],
  },
  {
    idPuesto: 22,
    idTerminalTarjeta: 0,
    nombre: "TOTEM-PEATONAL-1",
    combustiblesSoloPorDespachos: true,
    decimalesParaCantidad: 4,
    decimalesParaImporte: 2,
    verSaldoCliente: true,
    habilitarCambioListaPrecio: 0,
    habilitarAltaClientes: true,
    pideDepositoAlFacturar: false,
    idGrupoManguerasAForzar: 1,
    caja: {
      idCaja: 1,
      cantidadPlayerosSolicitados: 0,
      descripcion: "PLAYA",
      involucraTanques: false,
      involucraSurtidores: false,
      solicitarAforadores: true,
      estacion: null,
    },
    talonarios: [
      {
        idTalonario: 57,
        idDeposito: 2,
        descripcionTalonario: "FAA - PV 999",
        talonarioElectronico: true,
        pathCertificadoFAE: null,
        puntoVenta: 999,
        copias: 1,
        perteneceFULL: true,
        talonarioDocumentos: [
          {
            idTipoMovimiento: "FAA",
          },
          {
            idTipoMovimiento: "NCA",
          },
          {
            idTipoMovimiento: "NDA",
          },
          {
            idTipoMovimiento: "FAA",
          },
          {
            idTipoMovimiento: "NCA",
          },
          {
            idTipoMovimiento: "NDA",
          },
        ],
      },
      {
        idTalonario: 58,
        idDeposito: 2,
        descripcionTalonario: "FAB - PV 999",
        talonarioElectronico: true,
        pathCertificadoFAE: null,
        puntoVenta: 999,
        copias: 1,
        perteneceFULL: true,
        talonarioDocumentos: [
          {
            idTipoMovimiento: "FAB",
          },
          {
            idTipoMovimiento: "NCB",
          },
          {
            idTipoMovimiento: "NDB",
          },
          {
            idTipoMovimiento: "FAB",
          },
          {
            idTipoMovimiento: "NCB",
          },
          {
            idTipoMovimiento: "NDB",
          },
        ],
      },
      {
        idTalonario: 59,
        idDeposito: 2,
        descripcionTalonario: "REM - PV 999",
        talonarioElectronico: false,
        pathCertificadoFAE: null,
        puntoVenta: 999,
        copias: 2,
        perteneceFULL: true,
        talonarioDocumentos: [
          {
            idTipoMovimiento: "REM",
          },
          {
            idTipoMovimiento: "RDV",
          },
          {
            idTipoMovimiento: "REM",
          },
          {
            idTipoMovimiento: "RDV",
          },
        ],
      },
      {
        idTalonario: 60,
        idDeposito: 2,
        descripcionTalonario: "REM - PV 999",
        talonarioElectronico: false,
        pathCertificadoFAE: null,
        puntoVenta: 999,
        copias: 2,
        perteneceFULL: true,
        talonarioDocumentos: [
          {
            idTipoMovimiento: "REM",
          },
          {
            idTipoMovimiento: "RDV",
          },
          {
            idTipoMovimiento: "REM",
          },
          {
            idTipoMovimiento: "RDV",
          },
        ],
      },
    ],
  },
  {
    idPuesto: 17,
    idTerminalTarjeta: 0,
    nombre: "SHOP",
    isShop: true,
    combustiblesSoloPorDespachos: false,
    decimalesParaCantidad: 4,
    decimalesParaImporte: 2,
    verSaldoCliente: false,
    habilitarCambioListaPrecio: 0,
    habilitarAltaClientes: false,
    pideDepositoAlFacturar: false,
    idGrupoManguerasAForzar: null,
    caja: {
      idCaja: 2,
      cantidadPlayerosSolicitados: 1,
      descripcion: "SHOP",
      involucraTanques: false,
      involucraSurtidores: false,
      solicitarAforadores: false,
      estacion: null,
    },
    talonarios: [
      {
        idTalonario: 192,
        idDeposito: 2,
        descripcionTalonario: "FAA - PV - 96",
        talonarioElectronico: false,
        pathCertificadoFAE: null,
        puntoVenta: 96,
        copias: 3,
        perteneceFULL: false,
        talonarioDocumentos: [
          {
            idTipoMovimiento: "FAA",
          },
          {
            idTipoMovimiento: "NDA",
          },
          {
            idTipoMovimiento: "NCA",
          },
        ],
      },
      {
        idTalonario: 193,
        idDeposito: 2,
        descripcionTalonario: "FAB - PV - 96",
        talonarioElectronico: false,
        pathCertificadoFAE: null,
        puntoVenta: 96,
        copias: 2,
        perteneceFULL: false,
        talonarioDocumentos: [
          {
            idTipoMovimiento: "FAB",
          },
          {
            idTipoMovimiento: "NCB",
          },
          {
            idTipoMovimiento: "NDB",
          },
          {
            idTipoMovimiento: "TIK",
          },
        ],
      },
      {
        idTalonario: 194,
        idDeposito: 2,
        descripcionTalonario: "REM - PV - 96",
        talonarioElectronico: false,
        pathCertificadoFAE: null,
        puntoVenta: 96,
        copias: 2,
        perteneceFULL: false,
        talonarioDocumentos: [
          {
            idTipoMovimiento: "REM",
          },
        ],
      },
    ],
  },
];

const getPuestos = async () => {
  return PUSETOS_HARDCODED_YPF;
};

const puestos = {
  getPuestos,
};

export default puestos;
